import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft, Lock, Download } from "lucide-react";

const API_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const Step = ({ n, title, children }) => (
  <div className="flex gap-4">
    <div className="shrink-0 w-8 h-8 rounded-full bg-primary text-white grid place-items-center font-bold text-sm">{n}</div>
    <div className="pb-4">
      <p className="font-semibold text-primary">{title}</p>
      <p className="text-sm text-muted-foreground leading-relaxed mt-0.5">{children}</p>
    </div>
  </div>
);

export const Section = ({ id, icon: Icon, title, subtitle, children }) => (
  <section id={id} className="scroll-mt-20">
    <div className="flex items-center gap-3 mb-4">
      <div className="w-11 h-11 rounded-xl bg-secondary grid place-items-center">
        <Icon className="w-5 h-5 text-accent" />
      </div>
      <div>
        <h2 className="text-xl font-bold text-primary leading-tight">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
    <div className="bg-white rounded-2xl border border-border p-6 space-y-3">{children}</div>
  </section>
);

export const ManualShell = ({ badge, title, intro, children, testid, pdf }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-testid={testid}>
      <header className="bg-white border-b border-border sticky top-0 z-10 print:hidden">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2" data-testid="manual-home-link">
            <img src="/eim-logo.png" alt="EIM" className="w-9 h-9 object-contain" />
            <span className="font-heading font-extrabold text-lg text-primary">EIM Becas</span>
          </button>
          <div className="flex items-center gap-2">
            <Button variant="ghost" onClick={() => navigate("/")} data-testid="manual-back-btn">
              <ArrowLeft className="w-4 h-4 mr-1" /> Volver
            </Button>
            {pdf && (
              <a href={`${API_ORIGIN}/api/manuales/${pdf}`} target="_blank" rel="noreferrer" data-testid="manual-pdf-btn">
                <Button variant="outline" className="rounded-xl">
                  <Download className="w-4 h-4 mr-2" /> Descargar PDF
                </Button>
              </a>
            )}
            <Button onClick={() => window.print()} className="rounded-xl" data-testid="manual-print-btn">
              <Printer className="w-4 h-4 mr-2" /> Imprimir
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 py-10 space-y-10">
        <div className="text-center space-y-3">
          <img src="/eim-logo.png" alt="Estadio Israelita Maccabi" className="w-16 h-16 object-contain mx-auto" />
          <h1 className="text-3xl sm:text-4xl font-black text-primary">{title}</h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">{intro}</p>
          <div className="inline-flex items-center gap-2 bg-secondary text-primary px-4 py-2 rounded-full text-sm font-semibold">
            <Lock className="w-4 h-4" /> {badge}
          </div>
        </div>
        {children}
        <p className="text-center text-xs text-muted-foreground pt-4">
          EIM Becas · Estadio Israelita Maccabi · Documento de uso interno · Consultas a becas@eimbecas.cl
        </p>
      </main>
    </div>
  );
};
